import { useSelector } from "react-redux";
import { DISCARDED_CYLINDERS } from "../../../api/allApi_List";
import DialogBox from "../../../components/UI/DialogBox";
import spin from "../../../assets/icons/spin.png";
import { handleErrMessage } from "../../../functions/handleErrMessage";
import MainPageLayout from "../../../layout/MainPageLayout";
import useFetchData from "../../../CustomHooks/useAxios/useFetchData";
import DiscardedList from "../components/discarded/DiscardedList";

const DiscardedCylinderPage = () => {
  const { isLoaded } = useFetchData(DISCARDED_CYLINDERS);
  const data = useSelector((state) => state.data.data);
  const error = useSelector((state) => state.data.error);
  const errMsg = useSelector((state) => state.data.errMessage);
  const dataLength = isLoaded && !errMsg ? data.length : 0;

  return (
    <MainPageLayout
      headerConfig={{ title: "Discarded Cylinders" }}
      numberOfData={dataLength}
    >
      {isLoaded && !error ? (
        <DiscardedList cylinders={data} />
      ) : error ? (
        <DialogBox
          title="Error"
          message={handleErrMessage(errMsg)}
          isErrorHandleButtons={true}
        />
      ) : (
        <DialogBox message="Loading your data" animateIcon={spin} />
      )}
    </MainPageLayout>
  );
};

export default DiscardedCylinderPage;
